const basicCampaignsPath = (routePath = '') =>
  `campaigns${routePath && '/'}${routePath}`;

export const getCampaigns = () => basicCampaignsPath();
export const getCampaign = (id: string) => basicCampaignsPath(id);
export const createCampaign = () => basicCampaignsPath();
export const updateCampaign = (id: string) => basicCampaignsPath(id);
export const lauchCampaign = (id: string) => basicCampaignsPath(`${id}/launch`);
export const pauseCampaign = (id: string) => basicCampaignsPath(`${id}/pause`);
